import q from 'q'
import csSdkManager from '../managers/cs-sdk-manager'
import Router from '../router'
import * as errors from '../enums/error-codes'
import SearchResultsUtil from '../utils/search-results-util'
import * as _ from 'lodash'
import arrayUtil from '../utils/array-util'
import Metrics from '../services/metrics'
import PreviewImageUtil from '../utils/preview-image-util'
import LabInfoService from '../services/pages-info-service'
import identityStoreService from '../services/identity-store-service'
import createMetadataObject from '../utils/metadata-util'
import * as moderationStatus from '../enums/moderation-status'
import geoService from '../services/geo-ip-service'
import edgate from '../services/smart-edgate'
import * as sorting from '../enums/sorting.js'
import { fetch } from 'whatwg-fetch'
import { DEFAULT } from '../enums/regions'
const CONTENT_CREATION_TEAM_PENDING = 'CONTENT CREATION TEAM: PENDING'

export default {
  performSearch: (state, { searchText, key }) => {
    let query = {}
    if (_.isEmpty(searchText)) {
      searchText = null
    }
    query.searchText = searchText
    query.key = key
    Router.push({ name: 'Search', query })
  },
  setSearchCriteria: ({ commit }, { searchText }) => {
    commit('updateSearchText', searchText)
  },
  updateSelectedCategory: (state, category) => {
    state.commit('updateSelectedCategory', category)
  },
  fetchSortedContent: (state, { category, sortBy }) => {
    let fetchSortedContentTimer = Metrics.getAsyncTimer(
      Metrics.CP_TAGS.FETCH_MOST_POPULAR
    )
    let query = {
      sortBy
    }
    let csClient = csSdkManager.getCSClient({accessToken: state.getters.accessToken})
    csClient.searchForContent(query).then((results) => {
      fetchSortedContentTimer.done()
      state.commit('setCategoryContent', {
        category: category,
        content: results.data
      })
    })
  },
  fetchCategoryContent: (state, { category, labels }) => {
    let fetchHomeCategoryTimer = Metrics.getAsyncTimer(
      Metrics.CP_TAGS.FETCH_HOME_CATEGORY
    )
    let sortBy = sorting.SORT_BY_FEATURED
    let query = {
      labels,
      sortBy
    }
    let csClient = csSdkManager.getCSClient({accessToken: state.getters.accessToken})
    csClient.searchForContent(query).then((results) => {
      fetchHomeCategoryTimer.done()
      state.commit('setCategoryContent', {
        category: category,
        content: results.data.slice(0, 6)
      })
    })
  },
  fetchSearchResults: (
    state,
    {
      nextPageToken,
      limit,
      currentResults,
      currentPage,
      grades,
      subjects,
      componentTypes,
      countries,
      author,
      sortBy,
      keyword,
      labels,
      langPrefer,
      standardSets,
      standardStrands
    }
  ) => {
    let fetchSearchResultsTimer = Metrics.getAsyncTimer(
      Metrics.CP_TAGS.FETCH_SEARCH_RESULTS
    )
    let q = null
    if (keyword) {
      q = keyword
    } else if (state.getters.searchTerm) {
      q = state.getters.searchTerm
    }
    let query = {
      q,
      limit,
      nextPageToken,
      grades,
      subjects,
      componentTypes,
      countries,
      author,
      sortBy,
      labels,
      langPrefer,
      standardSets,
      standardStrands
    }
    let csClient = csSdkManager.getCSClient({accessToken: state.getters.accessToken})
    state.commit('setLoadingFlag', true)
    csClient
      .searchForContent(query)
      .then((results) => {
        fetchSearchResultsTimer.done()
        state.commit('setLoadingFlag', false)
        let newPage = currentPage
        newPage++
        state.commit('updatePaginationPage', newPage)
        if (results.data.length) {
          if (currentResults === null || !currentResults.items.length) {
            let searchResults = SearchResultsUtil.resolveItems(
              null,
              results.data,
              limit - 1
            )
            state.commit('setSearchResults', {
              content: searchResults,
              nextPageToken: results.nextPageToken
            })
          } else {
            let updatedResults = SearchResultsUtil.resolveItems(
              currentResults.items,
              results.data,
              limit
            )
            state.commit('setSearchResults', {
              content: updatedResults,
              nextPageToken: results.nextPageToken
            })
          }
        }
      })
      .catch(() => {
        state.commit('setLoadingFlag', false)
        state.commit('setErrorStatus', { status: errors.CP_301_ERROR })
      })
  },
  fetchResourceShareInfo(state, shareId) {
    let csClient = csSdkManager.getCSClient({region: DEFAULT})
    return csClient
      .resourceShareInfo(shareId)
  },
  fetchContentDetailWithBaseUrl(state, shareInfo) {
    let previewContentIds = null
    let csClient = csSdkManager.getCSClient({region: shareInfo.region.toLowerCase()})
    return csClient.getContentProfileWithBaseUrl(shareInfo.profileUrl)
      .then(details => {
        if (details.length === 0) throw new Error('404')
        let detail = _.first(details)
        let promises = []
        detail.previews = []
        if (!_.isUndefined(detail.lessonPersistDoc)) {
          promises.push(
            fetch(detail.lessonPersistDoc)
              .then((lpp) => {
                return lpp.json()
              })
              .then((lppInfo) => {
                detail.lppInfo = lppInfo
                previewContentIds = Object.keys(lppInfo.pages)
                let previewsIndex = PreviewImageUtil.getPreviewsIndex(lppInfo)
                // CS has a limit of 20 resources per request
                let previewBatches = arrayUtil.chunkArray(previewContentIds, 20)
                let prom = previewBatches.map((batch) =>
                  csClient.getContentProfile(batch)
                )
                return q
                  .all(prom)
                  .then((previews) => {
                    previews = _.flatten(previews)
                    return PreviewImageUtil.resolve(
                      previews,
                      detail,
                      previewContentIds,
                      previewsIndex
                    ).then((processedPreviews) => {
                      detail.previews = processedPreviews.detail.previews
                    })
                  })
                  .then(() => {
                    if (_.isEmpty(detail.previews)) {
                      detail.previewerList = []
                      detail.requiresStudentDevices = false
                      state.commit('upsertContentDetail', { detail, id: shareInfo.shareId })
                    } else {
                      return LabInfoService.extractInfo(
                        detail.lppInfo,
                        detail.previews,
                        previewsIndex
                      ).then((result) => {
                        // fetchContentDetailTimer.done()
                        detail.previewerList = result.previewerList
                        detail.requiresStudentDevices =
                          result.requiresStudentDevices
                        state.commit('upsertContentDetail', { detail, id: shareInfo.shareId })
                      })
                    }
                  })
              })
          )
          return q.all(promises)
        } else {
          detail.previewerList = []
          detail.requiresStudentDevices = false
          state.commit('upsertContentDetail', { detail, id: shareInfo.shareId })
        }
      })
  },
  fetchContentDetail: (state, { accessToken, id, region }) => {
    let fetchContentDetailTimer = Metrics.getAsyncTimer(
      Metrics.CP_TAGS.FETCH_CONTENT_DETAIL
    )
    let csClient = csSdkManager.getCSClient({accessToken: accessToken, region: region})
    let contentIds = [id]
    let previewContentIds = null
    return csClient.getContentProfile(contentIds).then((details) => {
      if (details.length === 0) throw new Error('404')
      let detail = _.first(details)
      let promises = []
      detail.previews = []
      if (!_.isUndefined(detail.lessonPersistDoc)) {
        promises.push(
          fetch(detail.lessonPersistDoc)
            .then((lpp) => {
              return lpp.json()
            })
            .then((lppInfo) => {
              detail.lppInfo = lppInfo
              previewContentIds = Object.keys(lppInfo.pages)
              let previewsIndex = PreviewImageUtil.getPreviewsIndex(lppInfo)
              // CS has a limit of 20 resources per request
              let previewBatches = arrayUtil.chunkArray(previewContentIds, 20)
              let prom = previewBatches.map((batch) =>
                csClient.getContentProfile(batch)
              )
              return q
                .all(prom)
                .then((previews) => {
                  previews = _.flatten(previews)
                  return PreviewImageUtil.resolve(
                    previews,
                    detail,
                    previewContentIds,
                    previewsIndex
                  ).then((processedPreviews) => {
                    detail.previews = processedPreviews.detail.previews
                  })
                })
                .then(() => {
                  if (_.isEmpty(detail.previews)) {
                    detail.previewerList = []
                    detail.requiresStudentDevices = false
                    state.commit('upsertContentDetail', { detail, id })
                  } else {
                    return LabInfoService.extractInfo(
                      detail.lppInfo,
                      detail.previews,
                      previewsIndex
                    ).then((result) => {
                      fetchContentDetailTimer.done()
                      detail.previewerList = result.previewerList
                      detail.requiresStudentDevices =
                        result.requiresStudentDevices
                      state.commit('upsertContentDetail', { detail, id })
                    })
                  }
                })
            })
        )
        return q.all(promises)
      } else {
        detail.previewerList = []
        detail.requiresStudentDevices = false
        state.commit('upsertContentDetail', { detail, id })
      }
    })
  },
  resolveStrandData: (state, guids) => {
    let promises = guids.map((guid) => edgate.lookup(guid))
    return q.all(promises)
  },
  storeIDData: (state, keyValue) => {
    return identityStoreService.storeData(keyValue)
  },
  fetchIDData: (state) => {
    return identityStoreService.fetchData()
  },
  cancelResourceUpload: (state) => {
    csSdkManager.getCSClient({accessToken: state.getters.accessToken}).cancelResourceUpload()
  },
  uploadContent: (state, file) => {
    return csSdkManager
      .getCSClient({accessToken: state.getters.accessToken})
      .uploadNewResource(file)
  },
  updateResourceFile: (state, { file, contentId }) => {
    return csSdkManager
      .getCSClient({accessToken: state.getters.accessToken})
      .updateResource(contentId, file)
  },
  transactionStatus: (state, transactionId) => {
    let deferred = q.defer()
    csSdkManager
      .getCSClient({accessToken: state.getters.accessToken})
      .getTransactionStatus(transactionId)
      .then((details) => {
        let status = details.text
        switch (status) {
          case '"queued"':
            deferred.notify('Processing')
            break
          case '"processed"':
            deferred.resolve('Processed')
            break
          case '"processing"':
            deferred.notify('Processing')
            break
          case '"failed"':
            deferred.resolve('Failed')
            break
        }
      })
      .catch((c) => {
        deferred.reject(c)
      })
    return deferred.promise
  },
  downloadContent: (state, {id, shareId, region, accessToken}) => {
    const options = {region: region}
    if (accessToken !== null) {
      options.accessToken = accessToken
    }
    let csClient = csSdkManager.getCSClient(options)
    return csClient.downloadSharedResourceUrl(id, shareId).then((result) => {
      return result
    })
  },
  cleanSetSearchCriteria: (state, searchCriteria) => {
    state.commit('updatePaginationPage', 0)
    state.commit('setSearchResults', { content: [], nextPageToken: null })
    state.commit('updateSearchText', searchCriteria)
  },
  setDefaultFilters: (state, filters) => {
    for (let filter of filters) {
      for (let item of filter.items) {
        if (item.id === 'all' || item.id === 'none') {
          item.selected = true
        } else {
          item.selected = false
        }
      }
    }
    state.commit('updateFilters', filters)
  },
  setDefaultAuthorFilter: (state) => {
    state.commit('updateAuthorFilter', null)
  },
  setDefaultKeywordFilter: (state) => {
    state.commit('updateKeywordFilter', null)
  },
  setDefaultFilterGroup: (state, { filters, filterGroup }) => {
    for (let filter of filters) {
      if (filter.title === filterGroup) {
        for (let item of filter.items) {
          if (item.id === 'all' || item.id === 'none') {
            item.selected = true
          } else {
            item.selected = false
          }
        }
      }
    }
    state.commit('updateFilters', filters)
  },
  updateSelectedFilters: (state, { filters, filterId, filterGroup }) => {
    if (filterGroup !== 'Standards') {
      for (let filter of filters) {
        if (filter.title === filterGroup) {
          for (let item of filter.items) {
            if (item.id === 'all') {
              if (item.selected) {
                item.selected = false
              }
            }
            if (item.id === filterId) {
              if (item.selected) {
                item.selected = false
              } else {
                item.selected = true
              }
            }
          }
        }
      }
      state.commit('updateFilters', filters)
    } else {
      state.commit('setSelectedStandard', filterId)
    }
  },
  updateAuthorFilter: (state, author) => {
    state.commit('updateAuthorFilter', author)
  },
  updateKeywordFilter: (state, keyword) => {
    state.commit('updateKeywordFilter', keyword)
  },
  setDefaultSorting: (state, items) => {
    items.map((item) => {
      item.selected = item.id === 'bestmatch'
    })
    state.commit('setDefaultSorting', items)
  },
  setMobileFiltersVisibility: (state) => {
    if (state.getters.mobileFiltersVisibility) {
      state.commit('setMobileFiltersVisibility', false)
    } else {
      state.commit('setMobileFiltersVisibility', true)
    }
  },

  initResourceMetadata: (state, { metadata, contentId, filters }) => {
    let updates = createMetadataObject.createMetadataObject(
      metadata,
      filters,
      true
    )
    let csClient = csSdkManager.getCSClient({accessToken: state.getters.accessToken})
    return csClient.initContent(contentId, updates)
  },

  putMetaData: (state, { metadata, contentId, filters }) => {
    let updates = createMetadataObject.createMetadataObject(metadata, filters)
    let csClient = csSdkManager.getCSClient({accessToken: state.getters.accessToken})
    return csClient.putContent(contentId, updates)
  },
  deleteResource: (state, contentId) => {
    state.commit('setDeclinedModerationResourceDefaults')
    state.commit('setApprovedModerationResourceDefaults')
    state.commit('setPendingModerationResourceDefaults')
    let csClient = csSdkManager.getCSClient({accessToken: state.getters.accessToken})
    return csClient.deleteResource(contentId)
  },
  fetchContentProfile: (state, id) => {
    let csClient = csSdkManager.getCSClient({accessToken: state.getters.accessToken})
    return csClient.getContentProfile(id)
  },
  fetchModeratedResources: (state, { status, nextPageToken }) => {
    let fetchModeratedResourcesTimer = Metrics.getAsyncTimer(
      Metrics.CP_TAGS.FETCH_MODERATED_RESOURCE
    )
    state.commit('setModeratedResourcesLoadingStatus', {
      status: status.toLowerCase(),
      loading: true
    })
    let csClient = csSdkManager.getCSClient({accessToken: state.getters.accessToken})
    csClient
      .getModerationResources(status, nextPageToken)
      .then((result) => {
        fetchModeratedResourcesTimer.done()
        if (!_.isEmpty(result.data)) {
          for (let item of result.data) {
            let resource = {
              contentId: item.contentId,
              status: item.status,
              lastModTime: item.lastModTime,
              declineInfo: item.declineInfo,
              declineReasons: item.declineReasons
            }
            csClient.getContentProfile([resource.contentId]).then((result) => {
              resource.author = _.has(result[0], 'author')
                ? result[0].author
                : ''
              resource.componentTypes = _.has(result[0], 'componentTypes')
                ? result[0].componentTypes
                : ''
              resource.previewUrl = _.has(result[0], 'defaultPreviewUrl')
                ? result[0].defaultPreviewUrl
                : ''
              resource.grades = _.has(result[0], 'grades')
                ? result[0].grades
                : ''
              resource.subjects = _.has(result[0], 'subjects')
                ? result[0].subjects
                : ''
              resource.tags = _.has(result[0], 'tags') ? result[0].tags : ''
              resource.title = _.has(result[0], 'title') ? result[0].title : ''
              resource.description = _.has(result[0], 'description')
                ? result[0].description
                : ''
              resource.country = _.has(result[0], 'country')
                ? result[0].country
                : ''
              resource.language = _.has(result[0], 'language')
                ? result[0].language
                : ''
              resource.standardSets = _.has(result[0], 'standardSets')
                ? result[0].standardSets
                : ''
              state.commit('setModeratedResources', {
                status: status,
                item: resource
              })
            })
          }
          if (result.nextPageToken) {
            state.dispatch('fetchModeratedResources', {
              status: status,
              nextPageToken: result.nextPageToken
            })
          }
        } else {
          state.commit('setModeratedResourcesLoadingStatus', {
            status: status.toLowerCase(),
            loading: false
          })
        }
      })
      .catch(() => {
        state.commit('setModeratedResourcesLoadingStatus', {
          status: status.toLowerCase(),
          loading: false
        })
      })
  },
  deleteDeclinedResources: (state) => {
    let csClient = csSdkManager.getCSClient({accessToken: state.getters.accessToken})
    let contentIds = state.getters.getDeclinedResources.map((item) => {
      return item.contentId
    })
    let prom = contentIds.map((batch) => csClient.deleteResource(batch))
    return q.all(prom)
  },
  deletePendingResources: (state) => {
    let csClient = csSdkManager.getCSClient({accessToken: state.getters.accessToken})
    let contentIds = state.getters.getPendingResources.map((item) => {
      return item.contentId
    })
    let prom = contentIds.map((batch) => csClient.deleteResource(batch))
    return q.all(prom)
  },
  changeResourceState: (state, { contentId, status, moderation, declineInfo, declineReasons }) => {
    let csClient = csSdkManager.getCSClient({accessToken: state.getters.accessToken})
    return csClient
      .modResourceStatus(contentId, status.toUpperCase(), declineInfo, declineReasons)
      .then(() => {
        let pendingResources = state.getters.getPendingResourcesQueue
        let filterPendingResources = pendingResources.filter(el => {
          return !(el.title).includes(CONTENT_CREATION_TEAM_PENDING)
        })
        let currentResourceIndex = filterPendingResources.findIndex((k) => k.contentId === contentId)
        let pendingQueuelength = filterPendingResources.length - 1
        let nextResource = null
        if (filterPendingResources[currentResourceIndex + 1] !== undefined) { // there are more resources in the queue, use the next one
          nextResource = filterPendingResources[currentResourceIndex + 1]
        } else { // there are no more resources in the queue after this one
          if (pendingQueuelength !== 0) { // go back to the first one
            nextResource = filterPendingResources[0]
          }
        }
        if (moderation) {
          state.commit('setResourceStatusModeration', { contentId, status })
        }
        return nextResource
      })
  },
  fetchModerationQue: (state, { status, nextPageToken }) => {
    let fetchModerationQueue = Metrics.getAsyncTimer(
      Metrics.CP_TAGS.FETCH_MODERATION_QUEUE
    )
    state.commit('setModerationQueueLoadingStatus', {
      status: status.toLowerCase(),
      loading: true
    })
    let csClient = csSdkManager.getCSClient({accessToken: state.getters.accessToken})
    return csClient
      .getModerationQue(status, nextPageToken)
      .then((result) => {
        fetchModerationQueue.done()
        if (!_.isEmpty(result.data)) {
          for (let item of result.data) {
            let resource = {
              contentId: item.contentId,
              status: item.status,
              lastModTime: item.lastModTime
            }
            csClient.getContentProfile([resource.contentId]).then((result) => {
              if (result.length > 0) {
                resource.author = _.has(result[0], 'author')
                  ? result[0].author
                  : ''
                resource.componentTypes = _.has(result[0], 'componentTypes')
                  ? result[0].componentTypes
                  : ''
                resource.previewUrl = _.has(result[0], 'defaultPreviewUrl')
                  ? result[0].defaultPreviewUrl
                  : ''
                resource.grades = _.has(result[0], 'grades')
                  ? result[0].grades
                  : ''
                resource.subjects = _.has(result[0], 'subjects')
                  ? result[0].subjects
                  : ''
                resource.tags = _.has(result[0], 'tags')
                  ? result[0].tags
                  : ''
                resource.title = _.has(result[0], 'title')
                  ? result[0].title
                  : ''
                resource.description = _.has(result[0], 'description')
                  ? result[0].description
                  : ''
                resource.country = _.has(result[0], 'country')
                  ? result[0].country
                  : ''
                resource.language = _.has(result[0], 'language')
                  ? result[0].language
                  : ''
                resource.standardSets = _.has(result[0], 'standardSets')
                  ? result[0].standardSets
                  : ''
                state.commit('setModerationQueue', {
                  status: status,
                  item: resource
                })
              }
            })
          }
          if (result.nextPageToken) {
            state.dispatch('fetchModerationQue', {status: status, nextPageToken: result.nextPageToken})
          } else {
            state.commit('setModerationQueueLoadingStatus', {status: status.toLowerCase(), loading: false})
          }
        } else {
          state.commit('setModerationQueueLoadingStatus', {
            status: status.toLowerCase(),
            loading: false
          })
        }
      })
      .catch(() => {
        state.commit('setModerationQueueLoadingStatus', {
          status: status.toLowerCase(),
          loading: false
        })
      })
  },
  fetchModerationQueues: (state, { status, nextPageToken }) => {
    let csClient = csSdkManager.getCSClient({accessToken: state.getters.accessToken})
    return csClient.getModerationQue(status, nextPageToken).then((result) => {
      if (!_.isEmpty(result.data)) {
        state.commit('setModerationQueues', { list: result.data })
        if (result.nextPageToken) {
          state.dispatch('fetchModerationQueues', {
            status,
            nextPageToken: result.nextPageToken
          })
        } else {
          state.commit('setModerationQueuesLoadingStatus', { loading: false })
        }
      } else {
        state.commit('setModerationQueuesLoadingStatus', { loading: false })
      }
      return result
    })
  },
  fetchUserModQueues: (state, { status, nextPageToken }) => {
    let csClient = csSdkManager.getCSClient({accessToken: state.getters.accessToken})
    return csClient
      .getModerationResources(status, nextPageToken)
      .then((result) => {
        if (!_.isEmpty(result.data)) {
          if (result.nextPageToken) {
            state.commit('setUserModQueues', { list: result.data })
            state.dispatch('fetchUserModQueues', {
              status,
              nextPageToken: result.nextPageToken
            })
          } else {
            state.commit('setModeratedQueuesLoadingStatus', { loading: false })
          }
        } else {
          state.commit('setModeratedQueuesLoadingStatus', { loading: false })
        }
        return result
      })
  },
  getResourceStatus: (state, { contentId }) => {
    if (state.getters.getUserModQueue.find((k) => k.contentId === contentId)) {
      let found = state.getters.getPendingResources.find(
        (k) => k.contentId === contentId
      )
      if (_.isUndefined(found)) {
        found = state.getters.getDeclinedResources.find(
          (k) => k.contentId === contentId
        )
        if (_.isUndefined(found)) {
          found = state.getters.getApprovedResources.find(
            (k) => k.contentId === contentId
          )
        }
      }
      return found
    } else {
      state.commit('setModeratedQueuesLoadingStatus', { loading: true })
      let fetchModeratedResourcesTimer = Metrics.getAsyncTimer(
        Metrics.CP_TAGS.FETCH_MODERATED_RESOURCE
      )
      return state
        .dispatch('fetchUserModQueues', {
          status: moderationStatus.PENDING.toUpperCase(),
          nextPageToken: null
        })
        .then(() => {
          return state
            .dispatch('fetchUserModQueues', {
              status: moderationStatus.DECLINED.toUpperCase(),
              nextPageToken: null
            })
            .then(() => {
              return state
                .dispatch('fetchUserModQueues', {
                  status: moderationStatus.APPROVED.toUpperCase(),
                  nextPageToken: null
                })
                .then(() => {
                  fetchModeratedResourcesTimer.done()
                })
            })
        })
    }
  },
  getResourceModerationStatus: (state, { contentId }) => {
    let csClient = csSdkManager.getCSClient({accessToken: state.getters.accessToken})
    return csClient
      .getModerationQue(status, null, null, [contentId])
      .then((response) => {
        return response.data[0]
      })
  },
  resolveUserLocation: (state) => {
    return geoService.resolveLocation()
  },
  updateFilterStrings: (state, { filterGroup, items }) => {
    let filters = state.getters.filters
    filters.find((x) => x.title === filterGroup).items = items
    state.commit('updateFilters', filters)
  },
  updateLangLoadStatus: (state, value) => {
    state.commit('setLangLoadStatus', value)
  },
  updateLocationFilter: (state, {locations, status}) => {
    let resolvedLocations = locations.map(location => {
      return {title: location, selected: false, count: locations.filter(l => l === location).length}
    })
    state.commit('setLocationFilter', {locations: _.uniqBy(resolvedLocations, 'title'), status})
  }
}
